import {PALETTE_IDS} from '#core/application/modules/ids.js';
import {DEFAULT_RANGE_FILTERS} from '#core/application/modules/bet-history/bet-history.range-filters';

import {COLOR, FONT} from '../theme.js';

export function getBetHistoryConfig() {
    return {
        custom: {
            [PALETTE_IDS.BET_HISTORY]: {
                BetHistoryDetails: {
                    selectionContainer: {
                        style: {
                            alignItems: 'flex-start',
                        },
                    },
                    bestOddsIcon: {
                        style: {
                            paddingTop: '2px',
                        },
                    },
                },
                //this is temporary solution to fix moj issue, delete as soon as MOJ-14663 done
                BetHistoryView: {
                    filters: {
                        rangeFilterOptions: DEFAULT_RANGE_FILTERS.filter(item => item.options?.value !== '20'),
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.BET_HISTORY]: {
                BET_HISTORY_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                BET_HISTORY_DETAILS_BG: COLOR.BRAND.BACKGROUND1,

                BET_HISTORY_FILTERS_DROPDOWN: {
                    SECONDARY_DROPDOWN_BG: COLOR.BRAND.BACKGROUND4,
                    SECONDARY_DROPDOWN_BORDER_COLOR: COLOR.BRAND.BACKGROUND4,
                },

                BET_HISTORY_DETAILS_LEGS_HEADER_TEXT: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                    fontSize: FONT.SIZE_XLARGE,
                    textTransform: 'uppercase',
                    fontStyle: 'italic',
                    color: COLOR.BRAND.FOREGROUND1,
                },

                BET_HISTORY_MOBILE_FILTERS_DROPDOWN: {
                    SECONDARY_DROPDOWN_BG: COLOR.BRAND.BACKGROUND4,
                    SECONDARY_DROPDOWN_BORDER_COLOR: COLOR.BRAND.BACKGROUND4,
                },

                BET_HISTORY_MOBILE_ERROR_TRY_AGAIN_BUTTON: {
                    SECONDARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontWeight: FONT.WEIGHT_BOLD,
                        textTransform: 'uppercase',
                    },
                    SECONDARY_BUTTON_BORDER_COLOR: COLOR.BRAND.FOREGROUND2,
                },
            },
        },
    };
}
